import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageLayout from "../../components/layout/PageLayout";
import TrendingBar from "../../components/football/TrendingBar";
import { HERO_IMAGES } from "../../lib/constants";
import api from "../../lib/api";

const STATUS_TABS = [
    { k: "", l: "All" },
    { k: "prospect", l: "Prospects" },
    { k: "drafted", l: "Drafted / NFL" },
    { k: "active", l: "Active NFL" },
];

export default function RoadToLeague() {
    const [players, setPlayers] = useState([]);
    const [status, setStatus] = useState("");

    useEffect(() => {
        const params = {};
        if (status) params.status = status;
        api.get("/football/players", { params }).then(r => setPlayers(r.data)).catch(() => {});
    }, [status]);

    return (
        <PageLayout>
            <section className="relative pt-28 pb-12 border-b border-white/10 overflow-hidden">
                <img src={HERO_IMAGES.football} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="section-label mb-5">Digital Beast · Road to the League</div>
                    <h1 className="font-display text-5xl md:text-7xl text-white leading-[0.9] tracking-tight" data-testid="rtl-heading">
                        HIGH SCHOOL → COLLEGE → <span className="text-[#d4af37]">NFL.</span>
                    </h1>
                    <p className="text-white/60 mt-4 max-w-2xl">One database following the football journey — from Friday nights to Sunday afternoons.</p>
                </div>
            </section>
            <TrendingBar />

            <section className="py-10">
                <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                    <div className="flex gap-2 mb-6" data-testid="rtl-tabs">
                        {STATUS_TABS.map(t => (
                            <button key={t.k} onClick={() => setStatus(t.k)}
                                className={`chip ${status === t.k ? "chip-active" : ""}`} data-testid={`rtl-tab-${t.k || "all"}`}>{t.l}</button>
                        ))}
                    </div>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="rtl-grid">
                        {players.map(p => (
                            <Link key={p.id} to={`/football/road-to-the-league/${p.slug}`}
                                className="surface surface-hover overflow-hidden group" data-testid={`rtl-player-${p.slug}`}>
                                <div className="relative aspect-[4/5]">
                                    <img src={p.hero_image || p.photo} alt={p.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms]" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                                    <div className="absolute top-3 right-3">
                                        <span className="chip chip-active">{p.nfl_status || "prospect"}</span>
                                    </div>
                                    <div className="absolute bottom-0 left-0 right-0 p-5">
                                        <div className="font-display text-2xl text-white">{p.name}</div>
                                        <div className="text-white/70 text-xs uppercase tracking-widest mt-1">{p.position}</div>
                                    </div>
                                </div>
                                <div className="p-4 text-xs space-y-1">
                                    <div className="flex justify-between"><span className="text-white/40">HS</span><span className="text-white/80">{p.high_school || "—"}</span></div>
                                    <div className="flex justify-between"><span className="text-white/40">College</span><span className="text-white/80">{p.college || "—"}</span></div>
                                    <div className="flex justify-between"><span className="text-white/40">NFL</span><span className="text-[#d4af37]">{p.nfl_team || "—"}</span></div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </PageLayout>
    );
}
